import { components } from 'type/ReportServiceSchema';
import {
  InsightsItemModel,
  mapInsightsItemDtoToModel,
} from 'api/dto/new/InsightsCompared/InsightsItem.dto';

export type InsightsLifecycleComparedDto = components['schemas']['InsightsLifecycleComparedReportResultDTO'];

export type InsightsLifecycleComparedModel = Readonly<{
  groups: Readonly<Record<string, string>>;
  insights: ReadonlyArray<InsightsItemModel>;
  numberOfRespondents: number;
}>;

export const mapInsightsLifecycleComparedDtoToModel = (
  dto: InsightsLifecycleComparedDto
): InsightsLifecycleComparedModel => ({
  groups: dto.groups,

  insights: dto.insights.map((insight) => mapInsightsItemDtoToModel(insight)),
  numberOfRespondents: dto.numberOfRespondents,
});
